import React, {forwardRef} from 'react';
import FeatureCard from './FeatureCard'; // Assuming FeatureCard is in the same directory

const features = [
  {
    title: 'AI Mentor',
    description: 'The AI Mentor is a cutting-edge feature designed to enhance learning and decision-making within educational settings. It provides intelligent suggestions, adaptive learning paths, and insightful data analysis to help teachers and students achieve their academic goals efficiently.',
    image: 'ask_me.webp',
    gradient: ['#3f51b5', '#7986cb'], // Medium blue gradient
  },
  {
    title: 'Online Diary',
    description: 'The Online Diary enables teachers to create and share lesson plans, homework assignments, and important updates with students and parents. With its intuitive interface and robust notification system, it keeps everyone informed and organized.',
    image: 'online_diary.webp',
    gradient: ['#26a69a', '#80cbc4'], // Light teal gradient
  },
  {
    title: 'My Bus',
    description: 'The My Bus feature offers real-time tracking for school transportation, ensuring safety and transparency. Parents can monitor the location of their child’s bus, and administrators can optimize routes for efficiency and timely pickups or drop-offs.',
    image: 'school_bus.webp',
    gradient: ['#d84315', '#ff8a65'], // Lighter reddish-orange gradient
  },
  {
    title: 'Fee Management',
    description: 'The Fee Management system simplifies the process of tracking and collecting school fees. It integrates seamlessly with existing ERP systems to provide automated reminders, receipts, and transparent records for both parents and school administrators.',
    image: 'fee_management.webp',
    gradient: ['#ab47bc', '#ce93d8'], // Light purple gradient
  },
  {
    title: 'Revision Hub',
    description: 'The Revision Hub is a comprehensive platform for students to access curated study materials, practice tests, and progress trackers. Designed to encourage effective revision habits, it helps students excel in their exams with confidence.',
    image: 'revision_hub.webp',
    gradient: ['#4caf50', '#81c784'], // Light green gradient
  },

  {
    title: 'and a lot more...',
    description: 'Discover a plethora of features tailored for modern education. From attendance tracking, notes management, exams, and assignments, we ensure seamless school operations. With a commitment to innovation, we continually introduce new features and tools to empower schools, teachers, and students.',
    image: 'more_features.webp',
    gradient: ['#1e88e5', '#90caf9'], // Cool blue gradient
  },
];

const FeaturesSection = forwardRef(({chatBoxRef}, ref)=>{

       // Scroll handler
       const handleScrollToChatBox = () => {
        console.log(`scrolling to chatbox ref ${chatBoxRef.current}`);
        if (chatBoxRef.current) {
          chatBoxRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
        }
      };

  return (
    <section ref={ref} className="relative py-16 min-h-screen bg-gradient-to-b from-gray-800 via-gray-900 to-black
     text-gray-300 flex flex-col items-center justify-center">
      <h2 className="text-2xl font-bold text-center mb-8">Core Features</h2>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6 px-8">
        {features.map((feature, index) => {
          const minimumDelay = 0.2;
          const delay = index==0?minimumDelay: minimumDelay + (index* 0.2)/(index+1);
          return  <FeatureCard key={index} feature={feature} delay={delay} />
        })}
      </div>

        {/* Scroll Indicator */}
        <div className="absolute bottom-4 text-white animate-bounce z-30"
      onClick={handleScrollToChatBox}>
        <span>Know more ↓</span>
      </div>

    </section>
  );
})


export default FeaturesSection;